const emailFilters = [
    { id: "email_filter_qualified", value: "email_filter_qualified", label: "Email all conversations with visitor contact details."},
    { id: "email_filter_send_all", value: "email_filter_send_all", label: "Email all conversations with at least one (1) visitor utterance."},
    { id: "email_filter_send_two", value: "email_filter_send_two", label: "Email all conversations with at least two (2) visitor utterances."},
    { id: "email_filter_send_none", value: "email_filter_send_none", label: "Do not email any conversations."},
];

export default emailFilters;